import { render } from "./SchemasSelect.vue?vue&type=template&id=2cd3c2ae&scoped=true"
import script from "./SchemasSelect.vue?vue&type=script&lang=js"
export * from "./SchemasSelect.vue?vue&type=script&lang=js"

import "./SchemasSelect.vue?vue&type=style&index=0&id=2cd3c2ae&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd3c2ae"]])

export default __exports__